import { render } from "./BreadcrumbComponent.vue?vue&type=template&id=c42bcc1a&scoped=true&ts=true"
import script from "./BreadcrumbComponent.ts?vue&type=script&lang=ts"
export * from "./BreadcrumbComponent.ts?vue&type=script&lang=ts"

import "./BreadcrumbComponent.scss?vue&type=style&index=0&id=c42bcc1a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c42bcc1a"]])

export default __exports__